import script from "./checkHandleList.vue?vue&type=script&setup=true&lang=js"
export * from "./checkHandleList.vue?vue&type=script&setup=true&lang=js"

import "./checkHandleList.vue?vue&type=style&index=0&id=07cd4fff&lang=css"

const __exports__ = script;

export default __exports__